import cx from 'classnames'
import { useFeature } from '@growthbook/growthbook-react'

import { Group, Post } from 'lib/_types'
import { useCurrentUser } from 'store/api/yay/user'

import PostAvatar from 'components/Post/PostItem/PostAvatar'
import PostUserName from 'components/Post/PostItem/PostUserName'
import PostTime from 'components/Post/PostItem/PostTime'
import PostContent from 'components/Post/PostContent'

import './style.scss'

const ReplyToTarget = ({
  post,
  replyPostMode,
  group,
  children,
}: {
  post: Post
  replyPostMode: undefined | 'repost' | 'reply' | 'edit'
  group: Partial<{ data: Group }>
  children: JSX.Element
}) => {
  const { data: currentUser } = useCurrentUser()
  const isReplyToTargetEnabled = useFeature('yay-11937')

  if (replyPostMode == 'reply' && isReplyToTargetEnabled?.on) {
    return (
      <div className="ReplyToTarget">
        <div
          className={cx('PostList__item', {
            'PostList__item--reply-to-target': true,
          })}
        >
          <div className="PostList__item__wrapper">
            <PostAvatar user={post?.user} isConversationLayoutSmall={false} />

            <div className="PostList__item__center">
              <PostUserName user={post?.user} />
              <PostTime createdAt={post?.created_at} />

              <PostContent
                post={post}
                group={group}
                isShared={false}
                forceMultiplePostImage
              />
            </div>
          </div>
        </div>

        <div
          className={cx('PostList__item', {
            'PostList__item--last': true,
          })}
        >
          <div className="PostList__item__wrapper">
            <div className="ReplyToTarget__self">
              <PostAvatar user={currentUser} isConversationLayoutSmall />
            </div>

            <div className="ReplyToTarget__children">
              <PostUserName user={currentUser} />

              {children}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return children
}

export default ReplyToTarget
